import NoticeList from './NoticeList';
export default NoticeList;